import React from 'react';
import S from './styles';
import dummy from '../../resources/icon.jpg';
import cly from '../../resources/cly.jpeg';
import hsj from '../../resources/hsj.png';
import swl from '../../resources/swl.jpeg';
import ts from '../../resources/ts.png';
import tt from '../../resources/tt.jpeg';
import jyb from '../../resources/jyb.jpeg';
import { SpeakerItem } from "../speaker-item"

const speakerList = [
  {
    name: 'Rubin',
    company: '이스트소프트',
    profile: jyb,
    email: 'dbqlsdl1234@naver.com',
    git: 'https://github.com/Dev-RubinJo',
    summary: '언제나 낮은 자세를 갖추려고 노력하는 개발자입니다.',
  }, {
    
    name: '태태',
    company: '정육각',
    profile: tt,
    email: 'taetae-dev@gmail.com',
    git: 'taetae-dev@gmail.com',
    summary: '클라이밍 하는 고기쟁이🥩',
  }, {
    name: '태승',
    company: '아파트너',
    profile: ts,
    email: 'ryan.son1002@gmail.com',
    git: 'https://github.com/ryan-son',
    blog: 'https://velog.io/@ryan-son',
    summary: '합리적인 해결책 찾기를 좋아합니다.',
    }, {
      name: '클라인',
      company: '카카오뱅크',
      profile: cly,
      email: 'kcw9028@naver.com',
      blog: 'https://cnoo.tistory.com',
      summary: '삽질을 싫어하는 프로삽질러  🫠',
    }, {
      name: '스위리',
      company: '카카오페이',
      profile: swl,
      email: 'sueaty.cho@gmail.com',
      git: 'https://github.com/sueaty',
      blog: 'www.sueaty.com',
      youtube: 'https://youtube.com/c/sueaty',
      summary: '스위리 쏘 스윗',
    }, {
      name: '한승진(HanSJin)',
      company: '닥터다이어리',
      profile: hsj,
      git: 'https://github.com/HanSJin',
      summary: '어,왔니?',
    },
]

export const Speakers = () => (
  <S.Section>
    <S.Title
      id='speakers'
      data-sal="slide-up"
      data-sal-delay="100"
      data-sal-duration="600"
      data-sal-easing="ease"
    >
      Speakers
    </S.Title>
    <S.Wrap>
      { speakerList.map((speaker, index) => (<SpeakerItem speaker={speaker} index={index} key={speaker.name} />))}
    </S.Wrap>

  </S.Section>
)
